import { Component, Inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export type IdleWarningResult = 'stay' | 'logout';

export interface IdleWarningDialogData {
  secondsRemaining$: Observable<number>;
}

@Component({
  selector: 'app-idle-warning-dialog',
  template: `
    <div role="alertdialog" aria-labelledby="idle-warning-title" aria-describedby="idle-warning-message">
      <div class="uw-modal-header">
        <div class="heading-container">
          <span id="idle-warning-title" class="heading2">{{ 'idle_timeout.title' | translate }}</span>
        </div>
      </div>
      <div class="uw-modal-content" id="idle-warning-message">
        <p>{{ 'idle_timeout.message' | translate }}</p>
        <p>
          {{ 'idle_timeout.countdown' | translate }}
          <strong>{{ formatTime(data.secondsRemaining$ | async) }}</strong>
        </p>
      </div>
      <div class="un-modal-footer align-right">
        <button mat-button [title]="'sidebar_menu.log_out' | translate" (click)="close('logout')">
          {{ 'sidebar_menu.log_out' | translate }}
        </button>
        <button mat-flat-button color="primary" cdkFocusInitial
          [title]="'idle_timeout.stay_logged_in' | translate" (click)="close('stay')">
          {{ 'idle_timeout.stay_logged_in' | translate }}
        </button>
      </div>
    </div>
  `,
  imports: [AsyncPipe, MatButton, TranslateModule],
})
export class IdleWarningDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<IdleWarningDialogComponent, IdleWarningResult>,
    @Inject(MAT_DIALOG_DATA) public data: IdleWarningDialogData
  ) {}

  close(result: IdleWarningResult): void {
    this.dialogRef.close(result);
  }

  formatTime(totalSeconds: number | null): string {
    const seconds = Math.max(0, totalSeconds ?? 0);
    const mm = Math.floor(seconds / 60);
    const ss = `${seconds % 60}`.padStart(2, '0');
    return `${mm}:${ss}`;
  }
}
